import isNil from "lodash/isNil"
import round from "lodash/round"
import moment from "moment"

import { isForeignCurrencyAddress } from "entities/billing-address"

export const EXCHANGE_RATE_DECIMALS = 5
export const OUTDATED_RATE_ERROR_CODE = "exchange_rate_outdated"
export const AMOUNT_IN_CURRENCY_KEYS = {
  rrp: "rrp_in_currency",
  purchase_price: "purchase_price_in_currency",
  retail_price: "retail_price_in_currency"
}

const toAmount = (value) => round(Number(value), 2).toFixed(2)

export const isBlank = (value) => isNil(value) || value === ""

export const isForeignCurrencyOffer = (values) =>
  !!values.accounting_offer && isForeignCurrencyAddress(values.billing_address)

export const prepareExchangeRateParams = (values) =>
  isForeignCurrencyOffer(values)
    ? {
        service_date: moment(values.service_date).format("YYYY-MM-DD"),
        exchange_rate: values.exchange_rate,
        exchange_rate_source: values.exchange_rate_source,
        exchange_rate_fetched_at: values.exchange_rate_fetched_at
      }
    : {}

export const eurToCurrency = (eur, rate) =>
  isBlank(eur) || !Number(rate) ? "" : toAmount(Number(eur) / Number(rate))

export const currencyToEur = (amount, rate) =>
  isBlank(amount) || !Number(rate)
    ? ""
    : toAmount(Number(amount) * Number(rate))

const applyRateToAmount = (product, eurKey, currencyKey, rate) => {
  if (!isBlank(product[currencyKey])) {
    return { [eurKey]: currencyToEur(product[currencyKey], rate) }
  }
  if (!isBlank(product[eurKey])) {
    return { [currencyKey]: eurToCurrency(product[eurKey], rate) }
  }
  return {}
}

export const hasMissingAmountsInCurrency = (products) =>
  products.some((product) =>
    Object.entries(AMOUNT_IN_CURRENCY_KEYS).some(
      ([eurKey, currencyKey]) =>
        !isBlank(product[eurKey]) && isBlank(product[currencyKey])
    )
  )

export const applyRateToAmounts = (products, rate) =>
  products.map((product) =>
    Object.entries(AMOUNT_IN_CURRENCY_KEYS).reduce(
      (result, [eurKey, currencyKey]) => ({
        ...result,
        ...applyRateToAmount(product, eurKey, currencyKey, rate)
      }),
      product
    )
  )
